export const isResidualEnabled = (residualSpecification) => {
    if (!residualSpecification) {
        return false;
    }
    return residualSpecification.min !== residualSpecification.max;
};
export const isResidualFixed = (residualSpecification) => {
    if (!residualSpecification) {
        return false;
    }
    return (residualSpecification.min > 0 &&
        residualSpecification.min === residualSpecification.max);
};
const removeDecimalError = (value) => {
    return parseFloat(value.toFixed(8));
};
export const getConvertedResidualSpecification = (residualSpecification) => {
    if (!residualSpecification) {
        return null;
    }
    return {
        min: removeDecimalError(residualSpecification.min * 100),
        max: removeDecimalError(residualSpecification.max * 100),
        step: removeDecimalError(residualSpecification.step * 100),
        default: removeDecimalError(residualSpecification.default * 100),
        current: 0,
    };
};
